import { css } from '@emotion/react';
import { TYPOGRAPHY2 } from '../Styles';

const NOTES_COUNT_BUBBLE_STYLE = css`
  label: NOTES_COUNT_BUBBLE_STYLE;
  color: var(--text);
  position: absolute;
  text-align: center;
  padding: 1px 4px;
`;

const NOTES_COUNT_BUBBLE_STYLE_SIZES = {
  small: css`
    ${TYPOGRAPHY2.tiny}
  `,
  medium: css`
    ${TYPOGRAPHY2.small}
  `,
  large: css`
    ${TYPOGRAPHY2.medium}
  `,
};

export const NotesCountBubble = ({
  count,
  backgroundColor,
  textColor,
  top = 4,
  right = 4,
  size = 'small',
}: {
  count: number;
  backgroundColor?: string;
  textColor?: string;
  top?: number;
  right?: number;
  size?: 'small' | 'medium' | 'large';
}) => (
  <div
    css={[NOTES_COUNT_BUBBLE_STYLE, NOTES_COUNT_BUBBLE_STYLE_SIZES[size]]}
    style={{ backgroundColor: backgroundColor || 'var(--background3)', color: textColor || 'var(--text)', top: top, right: right }}
  >
    {count}
  </div>
);
